import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
export function PriceBlock() {
  return <section id="oferta" className="py-24 bg-white relative" data-id="element-135">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-136">
        <FadeIn data-id="element-137">
          <div className="bg-sage-700 rounded-[2.5rem] p-8 md:p-16 text-center shadow-2xl relative overflow-hidden" data-id="element-138">
            {/* Decorative background */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0" data-id="element-139">
              <div className="absolute -top-24 -right-24 w-64 h-64 bg-sage-600 rounded-full blur-3xl opacity-50" data-id="element-140"></div>
              <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-sage-800 rounded-full blur-3xl opacity-50" data-id="element-141"></div>
            </div>

            <div className="relative z-10" data-id="element-142">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-143">
                Obtén el Bundle Completo <br className="hidden md:block" data-id="element-144" />
                <span className="text-sage-200" data-id="element-145">"S.O.S. Berrinches"</span>
              </h2>

              <p className="text-sage-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto" data-id="element-146">
                (PDF + Audio Guía + Checklists) hoy mismo. Recupera el control
                de tu hogar por menos de lo que cuesta una cena rápida.
              </p>

              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-8 max-w-md mx-auto mb-10" data-id="element-147">
                <p className="text-sage-200 font-medium uppercase tracking-wider text-sm mb-2" data-id="element-148">
                  Precio Especial
                </p>
                <div className="flex items-center justify-center gap-2 mb-6" data-id="element-149">
                  <span className="text-5xl md:text-6xl font-bold text-white" data-id="element-150">
                    $9.99
                  </span>
                  <span className="text-xl text-sage-200 font-medium mt-2" data-id="element-151">
                    USD
                  </span>
                </div>

                <ul className="text-left space-y-3 mb-8" data-id="element-152">
                  {['Acceso inmediato y de por vida', 'Garantía de satisfacción', 'Pago 100% seguro'].map((item, i) => <li key={i} className="flex items-center gap-3 text-sage-50" data-id="element-153">
                      <Check size={18} className="text-terracotta" data-id="element-154" />
                      <span data-id="element-155">{item}</span>
                    </li>)}
                </ul>

                <Button href="https://www.claridadpluslab.com/cart/48904461615347:1" className="w-full py-5 text-lg shadow-xl" data-id="element-156">
                  ¡SÍ, QUIERO RECUPERAR LA PAZ AHORA!
                </Button>
                <p className="text-sage-200 text-sm mt-4" data-id="element-157">
                  Acceso inmediato tras la compra.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}